var newsletterSamples = '[data-newsletter-sample]';
var newsletterForm = '.newsletter-signup-form';

function init() {
  setWaypoint();
}

function setWaypoint() {
  $(newsletterForm).waypoint(runAnimation, { offset: '90%' });
}

function runAnimation() {
  $(newsletterSamples).each(function () {
    var newsletterNum = $(this).data('newsletter-sample');
    $(this).addClass('newsletter-sample-' + newsletterNum);
  });
}

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/newsletter_samples.js